import { useIntl } from 'react-intl';

import { AccessUserTypes } from 'apps-common/types';
import { track } from 'apps-common/utils/analytics';

import { routes } from '../routes';
import { NavigationRow, SectionCard } from './SectionCard';
import { UserAccessCheck } from './UserAccessCheck';

// Should match the permissions that we use for <MembershipHubPage /> because everbody
// who can access the membership hub should be able to access the data export page.
export const exportDataPageExcludedUsers = [AccessUserTypes.UNFINISHED, AccessUserTypes.UNVERIFIED];

export const ExportData = () => {
  const intl = useIntl();

  return (
    <UserAccessCheck
      userAccessRights={{
        excludedUsers: exportDataPageExcludedUsers,
      }}
    >
      <SectionCard>
        <NavigationRow
          label={intl.formatMessage({ id: 'membership_hub_quicklink_export_data' })}
          href={routes.dataExport}
          onClick={() => {
            track({
              event: 'Link Clicked',
              payload: {
                cta: 'export_data',
                location: 'body',
              },
            });
          }}
        />
      </SectionCard>
    </UserAccessCheck>
  );
};
